// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K2uXn","type":"styles_type__2-a1Z","choices":"styles_choices__1iDQ8"};